import { scrubString } from './scrubSecrets';

export interface SafeError extends Error {
    code?: string | number;
    status?: number;
}

/**
 * Coerces a thrown value into an `Error` carrying only `name`, `message`,
 * `stack`, and optional primitive `code`/`status` — never `config`/`request`/
 * `response`. See PLT-102416.
 */
export function toSafeError(input: unknown): SafeError {
    let name = 'Error';
    let message = '';
    let stack: string | undefined;
    let code: string | number | undefined;
    let status: number | undefined;

    if (input instanceof Error) {
        name = input.name || 'Error';
        message = input.message || '';
        stack = input.stack;
    } else if (typeof input === 'string') {
        message = input;
    } else if (input && typeof input === 'object') {
        const o = input as Record<string, unknown>;
        if (typeof o.name === 'string') {
            name = o.name;
        }
        if (typeof o.message === 'string') {
            message = o.message;
        }
        if (typeof o.stack === 'string') {
            stack = o.stack;
        }
    } else {
        message = String(input);
    }

    if (input && typeof input === 'object') {
        const o = input as Record<string, unknown>;
        if (typeof o.code === 'string' || typeof o.code === 'number') {
            code = o.code;
        }
        if (typeof o.status === 'number') {
            status = o.status;
        }
    }

    const safe = new Error(scrubString(message)) as SafeError;
    safe.name = name;
    safe.stack = stack === undefined ? undefined : scrubString(stack);
    if (code !== undefined) {
        safe.code = code;
    }
    if (status !== undefined) {
        safe.status = status;
    }
    return safe;
}
